import React from 'react';
import { getImageData } from '@utilities';
import { usePageData } from '@context';
import type { PageContextProps } from '@context';

/**
 * Homepage Banner.
 */
const HomepageBanner: React.FC<{
  storybookImage?: string;
}> = () => {
  const { pageData }: PageContextProps = usePageData();

  if (!pageData) {
    return null;
  }

  const safeHero = getImageData('featured_banner_image', pageData);
  const safeMobileHero = getImageData('page_image', pageData);
  /**
   * Render.
   */
  if (safeHero && safeMobileHero) {
    return (
      <section className={`banner-wrapper homepage-banner`}>
        <div className="banner-image" />

        <div className="container large homepage-banner-container">
          <div className="banner-content">
            <h2>EmpowerMe</h2>
            <p>
              Sharing resources. <br /> Empowering patients.
            </p>
          </div>
        </div>
      </section>
    );
  }
  return null;
};
export default HomepageBanner;
